import type { TypedDocumentNode } from '@apollo/client';
import gql from 'graphql-tag';

import type { TermsOfServiceVersionResponse } from './fragments';
import { termOfService } from './fragments';

export const AuthenticatedRoutesQuery: TypedDocumentNode<AuthenticatedRoutesResponse> = gql`
  query AuthenticatedRoutesQuery {
    me {
      id
      motd
      shouldAcceptTos
    }
    tosVersions: termsOfService {
      ...TOS
    }
  }
  ${termOfService}
`;

export type AuthenticatedRoutesResponse = {
  me: {
    id: string;
    shouldAcceptTos: boolean;
    motd?: string | null;
  };
  tosVersions: TermsOfServiceVersionResponse[];
};
